var map = {
	"./about-brand-1.png": 9340,
	"./about-brand-10.png": 4537,
	"./about-brand-11.png": 4664,
	"./about-brand-12.png": 6470,
	"./about-brand-13.png": 8753,
	"./about-brand-2.png": 8818,
	"./about-brand-3.png": 8397,
	"./about-brand-4.png": 5944,
	"./about-brand-5.png": 5123,
	"./about-brand-6.png": 6647,
	"./about-brand-7.png": 3569,
	"./about-brand-8.png": 5433,
	"./about-brand-9.png": 3004,
	"./about-screen-blue-background.webp": 3722,
	"./about-screen-years.png": 319,
	"./about-section-map.webp": 4030,
	"./ac.png": 9067,
	"./banner-base.webp": 2778,
	"./bg.svg": 1034,
	"./grand-hotel-sofia.png": 2418,
	"./hero-section-background-2.webp": 2177,
	"./hero-section-background.webp": 9061,
	"./info-section-1.webp": 4263,
	"./info-section-2.webp": 8643,
	"./info-section-3.png": 6205,
	"./manufacturers-1.webp": 2733,
	"./manufacturers-2.webp": 1098,
	"./manufacturers-3.webp": 588,
	"./manufacturers-4.webp": 3043,
	"./manufacturers-section-background.webp": 4050,
	"./monbat.png": 1456,
	"./news01.webp": 1142,
	"./news02.png": 2676,
	"./partners-brand-1.webp": 368,
	"./partners-brand-10.webp": 5874,
	"./partners-brand-11.webp": 5261,
	"./partners-brand-12.webp": 6845,
	"./partners-brand-2.webp": 9387,
	"./partners-brand-3.webp": 7130,
	"./partners-brand-4.webp": 1835,
	"./partners-brand-5.webp": 2770,
	"./partners-brand-6.webp": 4130,
	"./partners-brand-7.webp": 8559,
	"./partners-brand-8.webp": 31,
	"./partners-brand-9.webp": 5012,
	"./partners-services.png": 2013,
	"./partners-video-1.webp": 2792,
	"./partners-video-2.webp": 7720,
	"./partners-video-3.webp": 6455,
	"./product-section-2.webp": 1497,
	"./product-section-background.webp": 2458,
	"./product_services.webp": 2698,
	"./prouct-section-3.webp": 9471,
	"./services-background.webp": 7029,
	"./services.webp": 2816,
	"./unicredit.png": 4473,
	"./users-section.webp": 4215
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;